// A form that did not validate comes back as a new page (status 422), at the top. Take the visitor to the block of the form,
// whatever the block or its anchor is called (one page websites: the anchor is made of the title of the block).
export default function initFormErrorScroll(options = {}) {
    const {
        errorSelectors = '.form-error, .is-invalid, .validation-error',
        // the block that holds the form: the section of a page block, else the form itself
        blockSelector = 'section[id], .section',
        scrollBehavior = 'auto' // auto = scroll-behavior of html: smooth unless reduced motion (base/_base.scss)
    } = options;

    document.addEventListener('DOMContentLoaded', function() {
        // An anchor in the URL (#contact) is the visitor's own choice
        if (window.location.hash) {
            return;
        }

        const form = document.querySelector(`form:has(${errorSelectors})`);
        if (!form) {
            return;
        }

        const target = form.closest(blockSelector) || form;
        const scrollToTarget = (behavior) => target.scrollIntoView({ behavior, block: 'start' });

        scrollToTarget(scrollBehavior);

        // Images above the block that load later push it down: once everything is loaded, align again, unless the
        // visitor has already moved the page on his own.
        let moved = false;
        const stop = () => { moved = true; };
        ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach((type) => window.addEventListener(type, stop, { once: true, passive: true }));

        const alignAgain = () => {
            if (!moved) {
                scrollToTarget('auto');
            }
        };
        if ('complete' === document.readyState) {
            window.setTimeout(alignAgain, 300);
        } else {
            window.addEventListener('load', () => window.setTimeout(alignAgain, 300), { once: true });
        }
    });
}
